import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { ContainerProps } from './interfaces';

import useStyles from './style';

const Container: FC<PropsWithChildren<ContainerProps>> = ({ className, children, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classNames('container', classes.container, className)} {...rest}>
      <div className={classNames('containerContent', classes.containerContent)}>{children}</div>
    </div>
  );
};

export default Container;
